<template>
    <section>
        <modal v-if="showModal" @close="$emit('close')"
            :title="'Usuarios en Zona: ' + (zone ? zone.name : '')"
            :sizeOfModal="'small'"
            :showElement="showModal">
            <template v-slot:modalContent>
                <sui-form @submit.prevent>
                    <sui-form-field>
                        <label>Selecciona un usuario</label>
                        <sui-dropdown
                            placeholder="Selecciona un usuario"
                            selection
                            search
                            :options="availableUsersOptions"
                            v-model="selectedUserId"
                        />
                    </sui-form-field>
                    <sui-button primary type="button" :disabled="!selectedUserId" class="right floated" @click="add">
                        Agregar
                    </sui-button>
                    <div style="clear: both;"></div>
                </sui-form>
                <sui-divider></sui-divider>
                <sui-table color="black" celled v-if="zoneUsers && zoneUsers.length">
                    <sui-table-header>
                        <sui-table-row>
                            <sui-table-header-cell>Usuario</sui-table-header-cell>
                            <sui-table-header-cell :width="2" textAlign="center"></sui-table-header-cell>
                        </sui-table-row>
                    </sui-table-header>
                    <sui-table-body>
                        <sui-table-row v-for="user in zoneUsers" :key="user.id">
                            <sui-table-cell>{{ user.fullName }}</sui-table-cell>
                            <sui-table-cell>
                                <sui-button negative type="button" @click="$emit('remove', user)">Eliminar</sui-button>
                            </sui-table-cell>
                        </sui-table-row>
                    </sui-table-body>
                </sui-table>
                <p v-else>No hay usuarios asignados a esta zona.</p>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button @click="$emit('close')">Cerrar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>

<script>
import Modal from '@/components/Helpers/Modal.vue'

export default {
    name: 'ZoneUsersModal',
    components: { Modal },
    props: ['showModal', 'zone', 'zoneUsers', 'availableUsersOptions'],

    data () {
        return { selectedUserId: null }
    },

    watch: {
        showModal (val) {
            if (val) this.selectedUserId = null
        }
    },

    methods: {
        add () {
            this.$emit('add', this.selectedUserId)
            this.selectedUserId = null
        }
    }
}
</script>
